export default __webpack_public_path__ + "442230f7903dd8307bfafb1098b58076.ogg";